import { getTimeWithTimeZone } from 'utility/general';
import { GET_DOWNLOAD_DOCUMENT } from 'store/key';
import { useDispatch } from 'react-redux';

const useCTAAmendmentData = ({ cta = [] }) => {
    const dispatch = useDispatch();
    const getDownloadDocument = (id) => {
        dispatch({
            type: GET_DOWNLOAD_DOCUMENT,
            payload: {
                data: {
                    id: id,
                    type: 'cta',
                }
            },
        });
    };
    const rawColumn = [
        {
            field: 'id',
            headerName: 'No.',
            width: 80,
            valueGetter: (params, index) => {
                return index + 1;
            },
        },
        {
            field: 'fileName', headerName: 'File Name', width: 200, valueGetter: (params) => {
                return <div
                    onClick={ () => getDownloadDocument(params.row.id)}
                    style={{ color: 'blue', cursor: 'pointer' }}>
                    {params.value }
                </div>
            }
        },
        {
            field: 'effectiveDtm', headerName: 'Effective Date / Amendment Date', width: 170,
            valueGetter: (params) => {
                return getTimeWithTimeZone(params.value).format('YYYY-MM-DD');
            },
        },
        { field: 'createdByFullName', headerName: 'Uploaded by', width: 170 },
        {
            field: 'updateDtm', headerName: 'Upload Date', width: 170,
            valueGetter: (params) => {
                return getTimeWithTimeZone(params.value).format('YYYY-MM-DD HH:mm:ss');
            },
        },
    ];

    return { columns: rawColumn, rawColumn: rawColumn, rows: cta ?? [] };
};

export default useCTAAmendmentData;
